import React from "react";
import { Link } from "react-router-dom";
import { Card, Row, Col } from "antd";

const LandingPage = () => {
  return (
    <div style={{ padding: "24px" }}>
      <Card title='Training Library' className="card-professional">
        <Row gutter={[16, 16]} justify="center">
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={8}
            xl={8}
            style={{ display: "flex", justifyContent: "center" }}
          >
            {/* <Link to="/library-fields-area" className="card-link">
              <div className="circular-card newCard-main-3">
                <h3>Training Material</h3>
              </div>
            </Link> */}
             <Link to="/business-group" className="card-link">
              <div className="circular-card newCard-main-3">
                <h3>Training Courses</h3>
              </div>
            </Link>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default LandingPage;
